// services/diagnosticsService.js
const API_URL = 'https://api.subtidal.com';

const authHeaders = (token) => ({
  'Authorization': `Token ${token}`,
  'Content-Type': 'application/json',
});

// GET /grids/<id>/diagnostics/ → { grid, grid_name, tiles: [{ mooring, buoy, ... }] }
// One tile per mooring in the grid.
export const getGridDiagnostics = async (gridId, token) => {
  const res = await fetch(`${API_URL}/grids/${gridId}/diagnostics/`, { headers: authHeaders(token) });
  if (!res.ok) throw new Error(`Failed to fetch grid diagnostics: ${res.status}`);
  return res.json();
};
